module.exports = new __parcel__URL__("logo.69af303e.webp").toString();